import { render, staticRenderFns } from "./AnnouncementBar.vue?vue&type=template&id=576366e0&scoped=true"
import script from "./AnnouncementBar.vue?vue&type=script&lang=js"
export * from "./AnnouncementBar.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementBar.vue?vue&type=style&index=0&id=576366e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576366e0",
  null
  
)

export default component.exports